export default __webpack_public_path__ + "static/media/javascript.2ede0c2f.svg";